import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { ImageComponent } from '@interacta-shared/ui';
import { getAvatarTextColor, getRandomColor } from '@interacta-shared/util';
import { ThemeMode } from '@interacta-shared/util-common';
import { getLogoFromTheme } from '@modules/chat/helpers/chat.utils';
import { CurrentChatStatus } from '@modules/state/models/chat-state.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-chat-panel-header',
    templateUrl: './chat-panel-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImageComponent, NgClass, TranslatePipe],
})
export class ChatPanelHeaderComponent {
    readonly currentChatStatus = input.required<CurrentChatStatus | null>();
    readonly theme = input.required<ThemeMode>();
    readonly isCollapsed = input(true);
    readonly unreadChatStatus = input(0);

    readonly defaultTitle = 'interacta chat';

    readonly color = computed(() =>
        getRandomColor(this.currentChatStatus()?.avatarColorHash ?? 0),
    );
    readonly textColor = computed(() =>
        getAvatarTextColor(this.currentChatStatus()?.avatarColorHash ?? 0),
    );
    private readonly isCollapsedAndNotClosed = computed(() => {
        const currentChatStatus = this.currentChatStatus();
        return (
            this.isCollapsed() &&
            currentChatStatus &&
            !currentChatStatus.isClosed
        );
    });
    readonly chatLogo = computed(() => getLogoFromTheme(this.theme()));
    readonly showCurrentChat = computed(() => this.isCollapsedAndNotClosed());

    readonly profileImg = computed(() =>
        this.isCollapsedAndNotClosed()
            ? (this.currentChatStatus()?.avatarImageUrl ?? null)
            : null,
    );

    readonly chatTitle = computed(() =>
        this.isCollapsedAndNotClosed()
            ? (this.currentChatStatus()?.title ?? this.defaultTitle)
            : this.defaultTitle,
    );
    readonly unreadChatOrMessages = computed(() =>
        this.isCollapsedAndNotClosed()
            ? (this.currentChatStatus()?.unreadMessagesCount ?? 0)
            : 0,
    );
}
